import React from 'react';
import { TranslationFunction } from '../../types';


interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  label: string;
  name: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helpText?: string;
  t: TranslationFunction; // Added for internal translations if needed, though labels are passed in
  disabled?: boolean;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ label, name, options, value, onChange, error, helpText, t, disabled }) => {
  return (
    <fieldset className="mb-4">
      <legend className="block text-sm font-medium text-gray-700 mb-1">{label}</legend>
      {helpText && <p className="text-xs text-gray-500 mb-2">{helpText}</p>}
      <div className="mt-2 space-y-2 sm:space-y-0 sm:flex sm:space-x-4">
        {options.map((option) => (
          <div key={option.value} className="flex items-center">
            <input
              id={`${name}-${option.value}`}
              name={name}
              type="radio"
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className="focus:ring-[#b98e4c] h-4 w-4 text-[#b98e4c] border-gray-300 transition duration-150"
              disabled={disabled}
            />
            <label htmlFor={`${name}-${option.value}`} className={`ml-2 block text-sm text-gray-700 ${disabled ? 'opacity-70 cursor-not-allowed' : ''}`}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </fieldset>
  );
};